import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "~src/modules/match_detail/AppBasketball.vue";
import router from "~src/modules/match_detail/router/basketball";
import { installShared } from "~src/utils";
import { globalMixin } from "~src/mixins/globalMixin";

const pinia = createPinia();
const app = createApp(App);

app.use(pinia);
app.use(router);
app.mixin(globalMixin);

// delay mount so we can load configuration
setTimeout(() => {
  installShared(app, "plugin_config_match_detail_basketball");
  app.mount("#match_detail_basketball-app");
}, 200);
